import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/patient-type";

export const pagingPatientType = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);

export const getPatientTypeById = (medicalEquipmentId) =>
  axios.get(API_PATH + "/get-by-id/" + medicalEquipmentId);

export const saveOrUpdatePatientType = (medicalEquipment) =>
  axios.post(API_PATH + "/save", medicalEquipment);

export const deletePatientType = (medicalEquipmentId) =>
  axios.delete(API_PATH + "/mark-delete/" + medicalEquipmentId);

export const syncPatientType = (obj) =>
  axios.post(API_PATH + "/sync-patient-type", obj);
